var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArchivedoccheck = function SvgArchivedoccheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "archive doc check")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#5F4025",
    points: "2,32 9,18 39,18 46,32 24,42 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A67C52",
    d: "M24,43c-0.141,0-0.282-0.03-0.414-0.09l-22-10c-0.248-0.112-0.438-0.32-0.529-0.577 c-0.09-0.256-0.073-0.538,0.048-0.781l7-14C8.275,17.214,8.621,17,9,17h30c0.379,0,0.725,0.214,0.895,0.553l7,14 c0.122,0.243,0.139,0.525,0.048,0.781c-0.091,0.256-0.282,0.464-0.529,0.577l-22,10C24.282,42.97,24.141,43,24,43z M3.358,31.519 L24,40.901l20.642-9.382L38.382,19H9.618L3.358,31.519z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M39,38H9c-0.552,0-1-0.448-1-1V2c0-0.552,0.448-1,1-1h30c0.552,0,1,0.448,1,1v35C40,37.552,39.552,38,39,38z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72C472",
    d: "M22,23c-0.256,0-0.512-0.098-0.707-0.293l-4-4c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0 L22,20.586l7.293-7.293c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-8,8C22.512,22.902,22.256,23,22,23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A67C52",
    d: "M31,31v5c0,0.552-0.448,1-1,1H18c-0.552,0-1-0.448-1-1v-5H2c-0.552,0-1,0.448-1,1v14c0,0.552,0.448,1,1,1h44 c0.552,0,1-0.448,1-1V32c0-0.552-0.448-1-1-1H31z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArchivedoccheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/archive doc check.b85bc7ea.svg";
export { ForwardRef as ReactComponent };